import type { PRODUCTS_GRID_DATA, PRODUCTS_GRID_PARAMS } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH } from '../../const'

const DEFAULT_PRODUCTS_GRID_PARAMS_DEVICE = () => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  padding: DEFAULT_PADDING(),
})

export const DEFAULT_PRODUCTS_GRID_PARAMS = (): PRODUCTS_GRID_PARAMS => ({
  pc: {
    ...DEFAULT_PRODUCTS_GRID_PARAMS_DEVICE(),
    cols: {
      value: 4,
      unit: 'fr',
    },
  },
  tablet: {
    ...DEFAULT_PRODUCTS_GRID_PARAMS_DEVICE(),
    cols: {
      value: 3,
      unit: 'fr',
    },
  },
  mobile: {
    ...DEFAULT_PRODUCTS_GRID_PARAMS_DEVICE(),
    cols: {
      value: 1,
      unit: 'fr',
    },
  },
})

export const DEFAULT_PRODUCTS_GRID_DATA = (): PRODUCTS_GRID_DATA => ({
  id: null,
  classes: null,
  styles: null,
  count: 12,
  systems: [],
  type: 'products-grid',
})
